(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["magnification-demo"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ritual-magnification')) {
  customElements.define('ritual-magnification', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = {signal: this.controller.signal};
      const slider = this.querySelector('input[type="range"]');
      if (!slider) return;
      const output = this.querySelector('output');
      const images = [...this.querySelectorAll('[data-reticle-id]')];
      const buttons = [...this.querySelectorAll('[data-select-reticle]')];
      const select = id => {
        const selected = images.find(item => item.dataset.reticleId === id);
        if (!selected) return;
        images.forEach(item => {item.hidden = item !== selected;});
        buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.selectReticle === id)));
        this.querySelector('[data-selected-name]').textContent = selected.dataset.label;
      };
      const update = () => {
        const value = Number(slider.value);
        const fraction = (value - Number(slider.min)) / (Number(slider.max) - Number(slider.min));
        const ratio = value / Number(slider.min);
        this.style.setProperty('--mag-scene-scale', String(ratio));
        this.style.setProperty('--mag-scale', this.dataset.focalPlane === 'ffp' ? String(ratio) : '1');
        this.style.setProperty('--mag-progress', `${fraction * 100}%`);
        output.value = String(value);
        slider.setAttribute('aria-valuetext', `${value}×`);
      };
      slider.addEventListener('input', update, options);
      slider.addEventListener('keydown', event => {
        if (!['ArrowUp','ArrowDown'].includes(event.key)) return;
        event.preventDefault();
        const next = Number(slider.value) + (event.key === 'ArrowDown' ? 0.5 : -0.5);
        slider.value = String(Math.max(Number(slider.min), Math.min(Number(slider.max), next)));
        update();
      }, options);
      this.querySelectorAll('[data-zoom]').forEach(button => button.addEventListener('click', () => {slider.value = button.dataset.zoom; update();}, options));
      buttons.forEach(button => button.addEventListener('click', () => select(button.dataset.selectReticle), options));
      document.addEventListener('shopify:block:select', event => {
        if (this.contains(event.target)) select(event.detail.blockId);
      }, options);
      select(images[0].dataset.reticleId);
      update();
    }
    disconnectedCallback() {this.controller?.abort();}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["triton-embedded-finder"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('triton-finder')) {
  class TritonFinder extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      try {
        this.copy = JSON.parse(this.querySelector('.tf__copy').content.textContent);
        this.products = JSON.parse(this.querySelector('.tf__products').content.textContent).filter(Boolean);
        this.stage = this.querySelector('.tf__stage');
        this.money = new Intl.NumberFormat(this.dataset.locale || 'en', {style:'currency',currency:this.dataset.currency || 'USD'});
        this.reset(false);
      } catch (error) { this.ready = false; }
    }
    node(tag, text, className) { const e=document.createElement(tag); if(text!==undefined)e.textContent=text;if(className)e.className=className;return e; }
    link(text,url,className='tf__link') { const e=this.node('a',text,className);e.href=url;return e; }
    button(text,run,className='tf__link') {const e=this.node('button',text,className);e.type='button';e.addEventListener('click',run);return e;}
    reset(focus=true) {
      this.answers={}; this.context=this.dataset.context || 'all';
      if(this.context!=='all') this.answers.family=this.context.includes('dnv')?'dnv':'scopes';
      if(this.context==='low_dnv')this.answers.detail='compact';
      if(this.context==='high_dnv')this.answers.detail='high';
      this.index=0;this.render(focus);
    }
    effectiveDistance() {
      const a=this.answers;
      return a.resolution==='revise'?(a.revised_distance || 'near'):(a.distance==='mixed'?a.furthest_distance:a.distance);
    }
    questions() {
      const a=this.answers,q=[];
      if(this.context==='all')q.push(['family','family']);
      if(a.family==='dnv') {
        if(!['low_dnv','high_dnv'].includes(this.context))q.push(['detail','dnv_detail']);
        q.push(['feature',a.detail==='compact'?'dnv_compact_priority':'dnv_feature']);
      } else if(a.family==='scopes') {
        q.push(['distance','scope_distance']);
        if(a.distance==='mixed')q.push(['furthest_distance','scope_furthest']);
        q.push(['focal_plane','scope_plane'],['low_power','scope_low_power']);
        const d=a.distance==='mixed'?a.furthest_distance:a.distance;
        if(['far','extended'].includes(d) && a.low_power==='one') {
          q.push(['resolution','scope_conflict']);
          if(a.resolution==='revise')q.push(['revised_distance','scope_revised_distance']);
        }
        q.push(['priority','scope_priority']);
      }
      return q;
    }
    digitalFeatureMatches(p,feature) {
      if(!feature || feature==='any')return true;
      if(feature==='compact_size')return /recon45/i.test(p.specs || p.title);
      if(feature==='manual_focus')return /starstrikex/i.test(p.specs || p.title);
      return feature==='pip'?['pip','lrf'].includes(p.feature):p.feature===feature;
    }
    candidates() {
      const a=this.answers;
      return this.products.filter(p=>p.family===a.family).flatMap(p=>{
        if(a.detail&&a.detail!=='any'&&p.family!=='red_dot'&&p.detail!==a.detail)return [];
        if(p.family==='dnv' && !this.digitalFeatureMatches(p,a.feature))return [];
        const variants=p.variants.filter(v=>{
          if(!v.available)return false;
          if(p.family==='red_dot'&&a.detail&&a.detail!=='any'&&!v.title.toLowerCase().includes(a.detail.toLowerCase()))return false;
          if(['lpvo','mpvo','hpvo'].includes(p.family)&&a.feature&&a.feature!=='any') {
            const m=v.title.match(/\d+[-–](\d+)x/i);const zoom=m?m[1]:p.feature;if(zoom!==a.feature)return false;
          }
          return true;
        }).sort((a,b)=>a.price-b.price);
        return variants.length?[{...p,variant:variants[0]}]:[];
      }).sort((a,b)=>a.variant.price-b.variant.price || a.title.localeCompare(b.title));
    }
    preferenceDifferences(p,v) {
      const a=this.answers,missing=[];
      if(a.detail && a.detail!=='any' && p.family!=='red_dot' && p.detail!==a.detail)missing.push('detail');
      if(p.family==='dnv' && !this.digitalFeatureMatches(p,a.feature))missing.push('feature');
      if(['lpvo','mpvo','hpvo'].includes(p.family) && a.feature && a.feature!=='any') {
        const m=v.title.match(/\d+[-–](\d+)x/i);if((m?m[1]:p.feature)!==a.feature)missing.push('feature');
      }
      return missing;
    }
    recommendations() {
      if(this.answers.family==='scopes')return this.scopeRecommendations();
      const exact=this.candidates();this.fallback=false;
      if(exact.length)return exact.slice(0,2);
      this.fallback=true;
      const a=this.answers;
      const rank=(x,y)=>x.missing.reduce((n,k)=>n+(k==='feature'?3:1),0)-y.missing.reduce((n,k)=>n+(k==='feature'?3:1),0) || x.variant.price-y.variant.price || x.title.localeCompare(y.title);
      const options=this.products.filter(p=>p.family===a.family).flatMap(p=>p.variants.filter(v=>p.family!=='red_dot'||!a.detail||a.detail==='any'||v.title.toLowerCase().includes(a.detail.toLowerCase())).map(v=>({...p,variant:v,missing:this.preferenceDifferences(p,v)})));
      const available=options.filter(p=>p.variant.available);
      const pool=(available.length?available:options).sort(rank);
      return pool.filter((p,i)=>pool.findIndex(other=>other.id===p.id)===i).slice(0,2);
    }
    scopeTraits(p,v) {
      const text=(p.specs || p.title || '').toLowerCase();
      const zoom=v.title.match(/(\d+)[-–](\d+)x/i) || text.match(/(\d+)[-–](\d+)x/i);
      return {min:zoom?Number(zoom[1]):null,max:zoom?Number(zoom[2]):Number(p.feature)};
    }
    scopeRecommendations() {
      const a=this.answers,d=this.effectiveDistance();this.scopeStatus='';
      const options=this.products.filter(p=>['lpvo','mpvo','hpvo'].includes(p.family)).flatMap(p=>p.variants.map(v=>({...p,variant:v,traits:this.scopeTraits(p,v)}))).filter(p=>{
        const t=p.traits;
        if(d==='extended')return p.family==='hpvo' && t.max>=24;
        if(d==='far')return p.family==='hpvo' && t.max>=(a.low_power==='high'?24:16);
        if((d==='near' && a.low_power==='high') || (d==='mid' && a.low_power==='one'))return p.family==='lpvo' && t.min===1 && t.max===10;
        if(d==='near')return p.family==='lpvo' && t.min===1 && t.max<=6;
        if(d==='mid')return (p.family==='mpvo' && t.max>=10) || (a.low_power==='high' && p.family==='hpvo' && t.max===16);
        return false;
      });
      const plane=a.focal_plane || 'any';
      const selected=options.filter(p=>plane==='any'||p.detail===plane);
      const available=selected.filter(p=>p.variant.available);
      const pool=available.length?available:selected;
      const rankIds={
        near:{compact:['8027808333872','8027827175472','8027827765296'],bright:['8027817214000','8027827175472'],adjustments:['8027827175472','8027842609200','8027817214000','8027834515504'],any:['8027827175472','8027842609200','8027817214000','8027834515504']},
        mid:{compact:['8027851554864','8027824357424','8027838087216'],bright:['8027824357424','8027843919920','8027838087216'],adjustments:['8027836252208','8027842248752','8027838087216'],any:['8027824357424','8027838087216']},
        far:{bright:['8027850997808','8027844509744'],any:['8027844509744','8027850997808']},
        extended:{bright:['8027850997808','8027844509744'],any:['8027844509744','8027850997808']}
      };
      let ids=(rankIds[d] || rankIds.near)[a.priority] || (rankIds[d] || rankIds.near).any;
      if((d==='near' && a.low_power==='high') || (d==='mid' && a.low_power==='one'))ids=a.priority==='bright'?['8027827241008','8027835138096','8027847721008']:['8027835138096','8027847721008','8027827241008'];
      if(d==='mid' && a.low_power==='high')ids=['8027838087216','8027844509744','8027842248752','8027836252208','8027824357424'];
      const rank=p=>{const i=ids.indexOf(String(p.id).split('/').pop());return i<0?100:i;};
      pool.sort((x,y)=>rank(x)-rank(y) || ((d==='far' && a.low_power!=='high')?x.traits.max-y.traits.max:0) || x.variant.price-y.variant.price || x.title.localeCompare(y.title));
      const distinct=pool.filter((p,i)=>pool.findIndex(other=>other.id===p.id)===i);
      let matches=distinct.slice(0,2);
      if(plane==='any' && available.length) {
        const firstFFP=distinct.find(p=>p.detail==='ffp'),firstSFP=distinct.find(p=>p.detail==='sfp');
        if(firstFFP && firstSFP)matches=[distinct[0],distinct[0].detail==='ffp'?firstSFP:firstFFP];
        else this.scopeStatus='one_plane';
      }
      this.canComparePlanes=plane!=='any' && !available.length && options.some(p=>p.variant.available && p.detail!==plane);
      if(!available.length)this.scopeStatus='unavailable';
      this.fallback=!available.length;
      return matches;
    }
    scopeExplanation(p) {
      const c=this.copy,t=p.traits,id=String(p.id).split('/').pop();
      const parts=[c['scope_'+p.family],c.scope_zoom.replace('{min}',String(t.min || '?')).replace('{max}',String(t.max)),c['plane_'+p.detail]];
      if(this.answers.priority==='compact' && p.family==='lpvo') {
        if(id==='8027808333872')parts.push(c.compact_nav);
        if(['8027827175472','8027827765296'].includes(id))parts.push(c.compact_sfp);
      }
      if(this.answers.priority==='bright' && p.family==='lpvo') {
        if(id==='8027827175472')parts.push(c.bright_ronin);
        if(['8027817214000','8027827241008'].includes(id))parts.push(c.bright_orion);
      }
      return parts.join(' ');
    }
    tradeoffs(p) {
      const c=this.copy,notes=[];
      if(!p.variant.available)notes.push(c.unavailable);
      if(this.answers.family==='scopes'){
        if(this.answers.low_power==='one' && p.traits.min!==1)notes.push(c.no_one);
        if(this.answers.priority==='compact' && p.family==='hpvo')notes.push(c.long_size_tradeoff);
        if(this.answers.priority==='adjustments')notes.push(c.controls_note);
        return notes;
      }
      this.preferenceDifferences(p,p.variant).forEach(key=>{
        const q=this.questions().find(([k])=>k===key);
        const name=q?q[1]:(key==='detail'?'dnv_detail':'dnv_feature');
        const label=c.questions[name]?.options.find(o=>o[0]===this.answers[key])?.[1]||this.answers[key];
        notes.push(c.preference_changed.replace('{preference}',label));
      });
      return notes;
    }
    focus() {const h=this.stage.querySelector('h3');h.tabIndex=-1;h.focus({preventScroll:true});if(this.getBoundingClientRect().top<0)this.stage.scrollIntoView({block:'start',behavior:'instant'});}
    render(focus=true) {
      const c=this.copy,q=this.questions();this.stage.replaceChildren();
      if(this.index>=q.length){this.results();if(focus)this.focus();return;}
      const [key,name]=q[this.index],question=c.questions[name];
      const total=this.answers.family?q.length:5;
      const meta=this.node('div',undefined,'tf__meta');meta.append(this.node('span',this.answers.family?`${c.step} ${this.index+1} ${c.of} ${total}`:c.choose_path),this.node('span',this.answers.family?(c.questions.family.options.find(o=>o[0]===this.answers.family)?.[1] || c.scope_label):c.eyebrow));this.stage.append(meta);
      const progress=this.node('div',undefined,'tf__progress');const bar=this.node('span');bar.style.width=((this.index+1)/total*100)+'%';progress.append(bar);this.stage.append(progress,this.node('h3',question.title),this.node('p',question.hint));
      const options=this.node('div',undefined,'tf__options');
      let choices=question.options;
      choices.forEach(([value,label,hint],i)=>{
        const b=this.button('',()=>{const order=['family','distance','furthest_distance','focal_plane','low_power','resolution','revised_distance','priority','detail','feature'];if(key==='family')this.answers={};this.answers[key]=value;for(const later of order.slice(order.indexOf(key)+1))delete this.answers[later];this.index++;this.render();},'tf__option');
        b.setAttribute('aria-pressed',String(this.answers[key]===value));b.append(this.node('span',String(i+1).padStart(2,'0'),'tf__icon'));
        const text=this.node('span');text.append(this.node('strong',label));if(hint)text.append(this.node('small',hint));b.append(text);options.append(b);
      });
      this.stage.append(options);
      if(this.answers.family==='dnv')this.stage.append(this.node('p',c.shipping,'tf__note'));
      this.actions();if(focus)this.focus();
    }
    actions(){const actions=this.node('div',undefined,'tf__actions');if(this.index>0)actions.append(this.button('← '+this.copy.back,()=>{this.index--;this.render();}));if(this.index>0||this.answers.family)actions.append(this.button(this.copy.restart,()=>this.reset()));this.stage.append(actions);}
    results(){
      const c=this.copy;this.matches=this.recommendations();this.stage.append(this.node('h3',c.results));if(this.answers.family==='scopes')this.stage.append(this.node('p',c.scope_disclaimer,'tf__note'));
      if(!this.matches.length){this.stage.append(this.node('p',this.answers.family==='scopes'?c.scope_no_match:c.empty),this.node('p',c.empty_help),this.link(c.contact,'/pages/contact'));}
      else {
        if(this.fallback)this.stage.append(this.node('p',this.answers.family==='scopes'?c.scope_unavailable:c.fallback_intro,'tf__notice'));
        const cards=this.node('div',undefined,'tf__cards');
        this.matches.forEach((p,i)=>{
          const card=this.node('article',undefined,'tf__card');card.append(this.node('span',!p.variant.available?c.unavailable:(this.fallback?c.closest_alternative:(i?c.alternative:c.top)),'tf__badge'));
          if(p.image){const img=this.node('img');img.src=p.image;img.alt=p.title;img.width=640;img.height=420;img.loading='lazy';card.append(img);}
          card.append(this.node('h4',p.title),this.node('div',this.money.format(p.variant.price/100),'tf__price'));
          if(p.variant.title!=='Default Title')card.append(this.node('p',p.variant.title));
          this.tradeoffs(p).forEach(note=>card.append(this.node('p',note,'tf__tradeoff')));
          card.append(this.node('p',this.answers.family==='scopes'?this.scopeExplanation(p):(this.answers.feature==='compact_size' && this.digitalFeatureMatches(p,'compact_size')?c.recon_reason:this.answers.feature==='manual_focus' && this.digitalFeatureMatches(p,'manual_focus')?c.starstrikex_reason:(p.note || (i?c.other:c.why)))),this.link(p.variant.available?c.view:c.check_availability,p.url+'?variant='+p.variant.id,'tf__button'));cards.append(card);
        });this.stage.append(cards,this.node('p',c.price_note,'tf__note'));if(this.matches.length===1 && !this.fallback)this.stage.append(this.node('p',c.single,'tf__note'));
      }
      if(this.answers.family==='dnv')this.stage.append(this.node('p',c.shipping,'tf__note'));
      if(this.answers.family==='scopes'){
        if(this.scopeStatus==='one_plane')this.stage.append(this.node('p',c.one_plane_note,'tf__note'));
        if(this.canComparePlanes)this.stage.append(this.button(c.compare_planes,()=>{this.answers.original_focal_plane=this.answers.original_focal_plane||this.answers.focal_plane;this.answers.focal_plane='any';this.render();},'tf__button'));
      }
      this.actions();if(this.dataset.signup==='true'&&this.dataset.site&&this.dataset.list)this.signup();
    }
    signup(){
      const c=this.copy,form=this.node('form',undefined,'tf__signup');form.append(this.node('h3',c.signup_title),this.node('p',c.signup_intro));
      const id='tf-email-'+this.querySelector('.tf__wrap').id;
      const label=this.node('label',c.email);label.htmlFor=id;
      const input=this.node('input',undefined,'tf__email');Object.assign(input,{type:'email',id,autocomplete:'email',required:true,maxLength:254});input.name='email';
      const consent=this.node('label',undefined,'tf__consent'),check=this.node('input');check.type='checkbox';check.required=true;check.name='marketing-consent';consent.append(check,this.node('span',c.consent));
      const submit=this.node('button',c.submit,'tf__button');submit.type='submit';
      const status=this.node('p');status.setAttribute('role','status');status.setAttribute('aria-live','polite');
      form.append(label,input,consent,this.link(c.privacy,'/policies/privacy-policy'),this.node('br'),submit,status);
      form.addEventListener('submit',async(event)=>{
        event.preventDefault();if(submit.disabled)return;if(!form.reportValidity()||!check.checked){status.textContent=c.consent_error;return;}
        submit.disabled=true;submit.textContent=c.sending;status.textContent='';status.className='';
        const properties={Triton_Quiz_Source:'Embedded Finder',Triton_Quiz_Version:'4',Triton_Quiz_Match_Type:this.fallback?'Closest alternative':this.answers.family==='scopes'?'Preference ranked':'Exact match',Triton_Quiz_Context:this.context,Triton_Quiz_Category:this.answers.family,Triton_Quiz_Preference:this.answers.detail||'any',Triton_Quiz_Feature:this.answers.feature||'any',Triton_Quiz_Distance:this.answers.distance||'Not asked',Triton_Quiz_Effective_Distance:this.answers.family==='scopes'?this.effectiveDistance():'Not asked',Triton_Quiz_Focal_Plane:this.answers.focal_plane||'Not asked',Triton_Quiz_Original_Focal_Plane:this.answers.original_focal_plane||this.answers.focal_plane||'Not asked',Triton_Quiz_Conflict_Resolution:this.answers.resolution||'Not needed',Triton_Quiz_Low_Power:this.answers.low_power||'Not asked',Triton_Quiz_Setup_Priority:this.answers.priority||'Not asked',Triton_Quiz_Currency:this.dataset.currency,Triton_Quiz_Recommendation:this.matches[0]?.title||'No match',Triton_Quiz_Product_ID:this.matches[0]?String(this.matches[0].id):'',Triton_Quiz_Alternative:this.matches[1]?.title||'',Triton_Quiz_Consent_Text:c.consent};
        const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),15000);
        try {
          const response=await fetch('https://a.klaviyo.com/client/subscriptions?company_id='+encodeURIComponent(this.dataset.site),{method:'POST',headers:{'Content-Type':'application/vnd.api+json','revision':'2026-07-15'},body:JSON.stringify({data:{type:'subscription',attributes:{custom_source:'Triton Embedded Finder',profile:{data:{type:'profile',attributes:{email:input.value.trim(),properties,subscriptions:{email:{marketing:{consent:'SUBSCRIBED'}}}}}}},relationships:{list:{data:{type:'list',id:this.dataset.list}}}}}),signal:controller.signal});
          if(response.status!==202)throw new Error('Signup not accepted');status.textContent=c.success;submit.textContent=c.success;input.disabled=true;check.disabled=true;
        } catch(error){status.className='tf__status-error';status.textContent=c.error;submit.disabled=false;submit.textContent=c.submit;} finally {clearTimeout(timer);}
      });this.stage.append(form);
    }
  }
  customElements.define('triton-finder',TritonFinder);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["triton-erd-videos"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('triton-youtube-card')) {
    customElements.define('triton-youtube-card', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-video-id]');
          if (!button || !this.contains(button)) return;
          const id = button.dataset.videoId;
          if (!/^[a-zA-Z0-9_-]{11}$/.test(id)) return;
          const frame = document.createElement('iframe');
          frame.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0&playsinline=1';
          frame.title = button.dataset.videoTitle;
          frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
          frame.allowFullscreen = true;
          frame.referrerPolicy = 'strict-origin-when-cross-origin';
          this.replaceChildren(frame);
          frame.focus();
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["triton-home-footage"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('triton-home-footage')) {
    customElements.define('triton-home-footage', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.abort = new AbortController();
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.cards = Array.from(this.querySelectorAll('.thf__card')).map(card => {
          const panels = Array.from(card.querySelectorAll('[data-panel]'));
          const choices = Array.from(card.querySelectorAll('[data-choice]'));
          if (!panels.length) return null;
          const state = { card, panels, video:panels[0].querySelector('video'), visible:false, stopped:this.motion.matches };
          panels.forEach(panel => {
            const video = panel.querySelector('video');
            const button = panel.querySelector('.thf__playback');
            video.muted = true;
            video.controls = false;
            video.pause();
            button.hidden = false;
            const update = () => {button.textContent = video.paused ? button.dataset.play : button.dataset.pause;};
            video.addEventListener('play', update, {signal:this.abort.signal});
            video.addEventListener('pause', update, {signal:this.abort.signal});
            button.addEventListener('click', () => {
              state.stopped = !video.paused;
              if (state.stopped) video.pause();
              else { this.loadVideo(video); video.play().catch(update); }
              update();
            }, {signal:this.abort.signal});
            update();
          });
          panels.forEach((panel,index) => panel.hidden = index !== 0);
          choices.forEach((choice,index) => choice.setAttribute('aria-pressed',String(index === 0)));
          choices.forEach(choice => choice.addEventListener('click', () => {
            panels.forEach(panel => {
              const active = panel.dataset.panel === choice.dataset.choice;
              panel.querySelector('video').pause();
              panel.hidden = !active;
              if (active) state.video = panel.querySelector('video');
            });
            choices.forEach(button => button.setAttribute('aria-pressed',String(button === choice)));
            card.querySelector('[data-active-caption]').textContent = choice.dataset.caption;
            state.stopped = this.motion.matches;
            this.sync(state);
          }, {signal:this.abort.signal}));
          return state;
        }).filter(Boolean);
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            const state = this.cards.find(item => item.card === entry.target);
            if (!state) return;
            state.visible = entry.isIntersecting;
            this.sync(state);
          });
        }, {threshold:0.15});
        this.cards.forEach(state => this.observer.observe(state.card));
        document.addEventListener('visibilitychange', () => this.cards.forEach(state => this.sync(state)), {signal:this.abort.signal});
        this.motion.addEventListener('change', event => {
          this.cards.forEach(state => {state.stopped = event.matches;this.sync(state);});
        }, {signal:this.abort.signal});
      }
      loadVideo(video) {
        if (!video.hasAttribute('src') && video.dataset.src) {
          video.src = video.dataset.src;
          video.load();
        }
      }
      sync(state) {
        if (state.visible && !state.stopped && !document.hidden) { this.loadVideo(state.video); state.video.play().catch(() => {}); }
        else state.video.pause();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.abort?.abort();
        this.cards?.forEach(state => state.video.pause());
        this.abort = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["triton-maxbright-reticles"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('triton-maxbright')) {
  customElements.define('triton-maxbright', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.choices = [...this.querySelectorAll('[data-reticle]')];
      this.active = this.dataset.initial;
      this.mode = 'default';
      this.zoomed = false;
      this.canvas = this.querySelector('[data-canvas]');
      this.variants = JSON.parse(this.querySelector('[data-variant-map]').textContent);
      this.abort = new AbortController();
      this.addEventListener('click', (event) => {
        const choice = event.target.closest('[data-reticle]');
        const mode = event.target.closest('[data-mode-choice]');
        const zoom = event.target.closest('[data-zoom]');
        if (choice) this.active = choice.dataset.reticle;
        if (mode) this.mode = mode.dataset.modeChoice;
        if (zoom) this.zoomed = !this.zoomed;
        if (choice || mode || zoom) this.renderState();
        if (zoom) requestAnimationFrame(() => {
          this.canvas.scrollLeft = this.zoomed ? (this.canvas.scrollWidth - this.canvas.clientWidth) / 2 : 0;
          this.canvas.scrollTop = this.zoomed ? (this.canvas.scrollHeight - this.canvas.clientHeight) / 2 : 0;
        });
      }, {signal:this.abort.signal});
      this.addEventListener('keydown', (event) => {
        const choice = event.target.closest('[data-reticle]');
        if (!choice || !['ArrowLeft','ArrowRight','ArrowUp','ArrowDown','Home','End'].includes(event.key)) return;
        event.preventDefault();
        let index = this.choices.indexOf(choice);
        if (event.key === 'Home') index = 0;
        else if (event.key === 'End') index = this.choices.length - 1;
        else index = (index + (['ArrowLeft','ArrowUp'].includes(event.key) ? -1 : 1) + this.choices.length) % this.choices.length;
        this.active = this.choices[index].dataset.reticle;
        this.choices[index].focus();
        this.renderState();
      }, {signal:this.abort.signal});
      document.addEventListener('change', (event) => {
        if (!(event.target instanceof HTMLElement) || event.target.closest('product-card,quick-add-dialog')) return;
        if (!event.target.closest('variant-picker') && event.target.getAttribute('name') !== 'id') return;
        const option = event.target instanceof HTMLSelectElement ? event.target.selectedOptions[0] : event.target;
        const variantId = option?.dataset.variantId || (event.target.getAttribute('name') === 'id' ? event.target.value : '');
        this.followVariant(variantId);
      }, {signal:this.abort.signal});
      window.addEventListener('popstate', () => this.followVariant(new URL(window.location.href).searchParams.get('variant')), {signal:this.abort.signal});
      this.renderState();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.initialized = false;
    }
    followVariant(id) {
      const pattern = this.variants[id];
      if (pattern && this.choices.some(choice => choice.dataset.reticle === pattern)) {
        this.active = pattern;
        this.renderState();
      }
    }
    renderState() {
      this.dataset.mode = this.mode;
      this.classList.toggle('is-zoomed', this.zoomed);
      this.choices.forEach(choice => choice.setAttribute('aria-pressed', String(choice.dataset.reticle === this.active)));
      this.querySelectorAll('[data-mode-choice]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.modeChoice === this.mode)));
      this.querySelectorAll('[data-panel]').forEach(panel => panel.hidden = panel.dataset.panel !== this.active);
      const current = this.choices.find(choice => choice.dataset.reticle === this.active);
      if (current) this.querySelector('[data-active-name]').textContent = current.dataset.title;
      const zoom = this.querySelector('[data-zoom]');
      zoom.setAttribute('aria-pressed', String(this.zoomed));
      zoom.textContent = this.zoomed ? zoom.dataset.zoomOut : zoom.dataset.zoomIn;
      this.querySelector('.triton-maxbright__pan').hidden = !this.zoomed;
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["triton-pro-ultra-reticles"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('triton-pro-reticles')) {
  customElements.define('triton-pro-reticles', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.choices = [...this.querySelectorAll('[data-reticle]')];
      this.active = this.choices[0]?.dataset.reticle;
      this.mode = 'default';
      this.zoomed = false;
      this.canvas = this.querySelector('[data-canvas]');
      this.addEventListener('click', (event) => {
        const choice = event.target.closest('[data-reticle]');
        const mode = event.target.closest('[data-mode-choice]');
        const zoom = event.target.closest('[data-zoom]');
        if (choice) this.active = choice.dataset.reticle;
        if (mode) this.mode = mode.dataset.modeChoice;
        if (zoom) this.zoomed = !this.zoomed;
        if (choice || mode || zoom) this.renderState();
        if (zoom) requestAnimationFrame(() => {
          this.canvas.scrollLeft = this.zoomed ? (this.canvas.scrollWidth - this.canvas.clientWidth) / 2 : 0;
          this.canvas.scrollTop = this.zoomed ? (this.canvas.scrollHeight - this.canvas.clientHeight) / 2 : 0;
        });
      });
      this.addEventListener('keydown', (event) => {
        const choice = event.target.closest('[data-reticle]');
        if (!choice || !['ArrowLeft','ArrowRight','ArrowUp','ArrowDown','Home','End'].includes(event.key)) return;
        event.preventDefault();
        let index = this.choices.indexOf(choice);
        if (event.key === 'Home') index = 0;
        else if (event.key === 'End') index = this.choices.length - 1;
        else index = (index + (['ArrowLeft','ArrowUp'].includes(event.key) ? -1 : 1) + this.choices.length) % this.choices.length;
        this.active = this.choices[index].dataset.reticle;
        this.choices[index].focus();
        this.renderState();
      });
      this.addEventListener('shopify:block:select', (event) => {
        if (this.choices.some(choice => choice.dataset.reticle === event.detail.blockId)) {
          this.active = event.detail.blockId;
          this.renderState();
        }
      });
      this.renderState();
    }
    renderState() {
      this.dataset.mode = this.mode;
      this.classList.toggle('is-zoomed', this.zoomed);
      this.choices.forEach(choice => choice.setAttribute('aria-pressed', String(choice.dataset.reticle === this.active)));
      this.querySelectorAll('[data-mode-choice]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.modeChoice === this.mode)));
      this.querySelectorAll('[data-panel]').forEach(panel => panel.hidden = panel.dataset.panel !== this.active);
      const current = this.choices.find(choice => choice.dataset.reticle === this.active);
      if (current) {
        this.querySelector('[data-active-name]').textContent = current.dataset.title;
        this.querySelector('[data-active-units]').textContent = current.dataset.units;
      }
      const zoom = this.querySelector('[data-zoom]');
      zoom.setAttribute('aria-pressed', String(this.zoomed));
      zoom.textContent = this.zoomed ? zoom.dataset.zoomOut : zoom.dataset.zoomIn;
      this.querySelector('.triton-pro-reticles__pan').hidden = !this.zoomed;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["triton-product-explorer"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('triton-product-explorer'))customElements.define('triton-product-explorer',class extends HTMLElement{
    connectedCallback(){
      if(this.initialized)return;this.initialized=true;
      this.addEventListener('click',event=>{const button=event.target.closest('[data-explore]');if(button&&this.contains(button))this.select(button.dataset.explore)});
      this.addEventListener('keydown',event=>{const buttons=Array.from(this.querySelectorAll('[data-explore]'));const index=buttons.indexOf(event.target);if(index<0)return;let next;if(event.key==='ArrowRight')next=(index+1)%buttons.length;else if(event.key==='ArrowLeft')next=(index-1+buttons.length)%buttons.length;else if(event.key==='Home')next=0;else if(event.key==='End')next=buttons.length-1;else return;event.preventDefault();buttons[next].focus();this.select(buttons[next].dataset.explore)});
      this.addEventListener('shopify:block:select',event=>this.select(event.detail.blockId));
    }
    select(id){this.querySelectorAll('[data-explore]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.explore===id)));this.querySelectorAll('[data-explore-panel]').forEach(panel=>panel.hidden=panel.dataset.explorePanel!==id)}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["triton-reticle-selector"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('triton-reticle-selector')) {
    customElements.define('triton-reticle-selector', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';
        this.activeReticle = 'cqb-d';
        this.mode = 'default';

        this.querySelectorAll('[data-reticle]').forEach((button) => {
          button.addEventListener('click', () => {
            this.activeReticle = button.dataset.reticle;
            this.querySelectorAll('[data-reticle]').forEach((choice) => {
              const active = choice === button;
              choice.classList.toggle('is-active', active);
              choice.setAttribute('aria-selected', active ? 'true' : 'false');
            });
            this.renderState();
          });
        });

        this.querySelectorAll('[data-mode]').forEach((button) => {
          button.addEventListener('click', () => {
            this.mode = button.dataset.mode;
            this.querySelectorAll('[data-mode]').forEach((choice) => {
              const active = choice === button;
              choice.classList.toggle('is-active', active);
              choice.setAttribute('aria-pressed', active ? 'true' : 'false');
            });
            this.renderState();
          });
        });
      }

      renderState() {
        this.querySelectorAll('[data-reticle-art]').forEach((art) => {
          art.toggleAttribute('hidden', art.dataset.reticleArt !== this.activeReticle);
        });
        this.querySelectorAll('[data-dimensions]').forEach((dimensions) => {
          dimensions.toggleAttribute('hidden', this.mode !== 'subtensions' || dimensions.dataset.dimensions !== this.activeReticle);
        });
        const unit = this.querySelector('.triton-reticle__unit');
        if (unit) unit.toggleAttribute('hidden', this.mode !== 'subtensions');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["triton-review-carousel"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('triton-review-carousel')) {
  customElements.define('triton-review-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('ul');
      this.controls = this.closest('.tr-reviews').querySelector('.tr-reviews__controls');
      this.controls.hidden = false;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.update = () => {
        const max = this.track.scrollWidth - this.track.clientWidth;
        this.controls.querySelector('[data-step="-1"]').disabled = this.track.scrollLeft <= 2;
        this.controls.querySelector('[data-step="1"]').disabled = this.track.scrollLeft >= max - 2;
      };
      this.controls.addEventListener('click', (event) => {
        const button = event.target.closest('button');
        const card = this.track.querySelector('li');
        if (!button || !card) return;
        const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
        this.track.scrollBy({left: Number(button.dataset.step) * (card.getBoundingClientRect().width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }, {signal});
      this.track.addEventListener('scroll', this.update, {passive:true,signal});
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.track);
      this.update();
    }
    disconnectedCallback() {this.abort?.abort();this.observer?.disconnect();}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["triton-scope-footage"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('triton-scope-footage')) {
  customElements.define('triton-scope-footage', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.panels = Array.from(this.querySelectorAll('[data-panel]'));
      this.choices = Array.from(this.querySelectorAll('[data-choice]'));
      if (!this.panels.length) return;
      this.active = this.panels.find(panel => panel.dataset.panel === this.dataset.initial) || this.panels[0];
      this.remembered = {};
      this.abort = new AbortController();
      this.querySelectorAll('[data-enhanced]').forEach(element => element.hidden = false);
      this.addEventListener('click', event => {
        const choice = event.target.closest('[data-choice]');
        const mode = event.target.closest('[data-mode]');
        if (choice) this.active = this.panels.find(panel => panel.dataset.panel === choice.dataset.choice);
        if (mode) this.active = this.remembered[mode.dataset.mode] || this.panels.find(panel => panel.dataset.group === mode.dataset.mode);
        if (choice || mode) this.updateView();
      }, {signal:this.abort.signal});
      this.addEventListener('shopify:block:select', event => {
        const selected = event.target.closest('[data-panel]');
        if (selected && this.contains(selected)) {this.active = selected;this.updateView();}
      }, {signal:this.abort.signal});
      this.updateView();
    }
    updateView() {
      if (!this.active) return;
      const group = this.active.dataset.group;
      this.remembered[group] = this.active;
      this.panels.forEach(panel => panel.hidden = panel !== this.active);
      this.choices.forEach(button => {
        button.hidden = button.dataset.group !== group;
        button.setAttribute('aria-pressed', String(button.dataset.choice === this.active.dataset.panel));
      });
      this.querySelectorAll('[data-mode]').forEach(button => {
        button.hidden = !this.panels.some(panel => panel.dataset.group === button.dataset.mode);
        button.setAttribute('aria-pressed', String(button.dataset.mode === group));
      });
      this.querySelector('[data-full]').href = this.active.querySelector('img').src;
    }
    disconnectedCallback() {this.abort?.abort();this.abort = null;}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["triton-scope-reticles"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('triton-scope-reticles')) {
  customElements.define('triton-scope-reticles', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.choices = [...this.querySelectorAll('[data-reticle]')];
      this.active = (this.choices.find(choice => choice.dataset.code === this.dataset.initialPattern) || this.choices[0])?.dataset.reticle;
      this.variantMap = JSON.parse(this.querySelector('[data-variant-map]')?.textContent || '{}');
      this.mode = 'default';
      this.zoomed = false;
      this.canvas = this.querySelector('[data-canvas]');
      this.addEventListener('click', (event) => {
        const choice = event.target.closest('[data-reticle]');
        const mode = event.target.closest('[data-mode-choice]');
        const zoom = event.target.closest('[data-zoom]');
        if (choice) this.active = choice.dataset.reticle;
        if (mode) this.mode = mode.dataset.modeChoice;
        if (zoom) this.zoomed = !this.zoomed;
        if (choice || mode || zoom) this.renderState();
        if (zoom) requestAnimationFrame(() => {
          this.canvas.scrollLeft = this.zoomed ? (this.canvas.scrollWidth - this.canvas.clientWidth) / 2 : 0;
          this.canvas.scrollTop = this.zoomed ? (this.canvas.scrollHeight - this.canvas.clientHeight) / 2 : 0;
        });
      });
      this.addEventListener('keydown', (event) => {
        const choice = event.target.closest('[data-reticle]');
        if (!choice || !['ArrowLeft','ArrowRight','ArrowUp','ArrowDown','Home','End'].includes(event.key)) return;
        event.preventDefault();
        let index = this.choices.indexOf(choice);
        if (event.key === 'Home') index = 0;
        else if (event.key === 'End') index = this.choices.length - 1;
        else index = (index + (['ArrowLeft','ArrowUp'].includes(event.key) ? -1 : 1) + this.choices.length) % this.choices.length;
        this.active = this.choices[index].dataset.reticle;
        this.choices[index].focus();
        this.renderState();
      });
      this.addEventListener('shopify:block:select', (event) => {
        if (this.choices.some(choice => choice.dataset.reticle === event.detail.blockId)) {
          this.active = event.detail.blockId;
          this.renderState();
        }
      });
      this.onVariantChange = (event) => {
        const detail = event.detail || {};
        const option = event.target?.selectedOptions?.[0] || event.target;
        const id = option?.dataset?.variantId || detail.variant?.id || detail.data?.variant?.id || detail.data?.productVariant?.id || detail.variantId;
        if (id) this.followVariant(id);
        else if (event.target?.matches?.('input[name="id"],select[name="id"]')) this.followVariant(event.target.value);
      };
      this.onHistoryChange = () => {const id = new URL(location.href).searchParams.get('variant'); if (id) this.followVariant(id);};
      this.variantEvents = ['variant:change','variant:changed','variant-change','variant:update','change'];
      this.variantEvents.forEach(name => document.addEventListener(name, this.onVariantChange));
      window.addEventListener('popstate', this.onHistoryChange);
      this.renderState();
    }
    disconnectedCallback() {
      this.variantEvents?.forEach(name => document.removeEventListener(name, this.onVariantChange));
      window.removeEventListener('popstate', this.onHistoryChange);
      this.initialized = false;
    }
    followVariant(id) {
      const code = this.variantMap[String(id)];
      const match = this.choices.find(choice => choice.dataset.code === code);
      if (match) {this.active = match.dataset.reticle; this.renderState();}
    }
    renderState() {
      this.dataset.mode = this.mode;
      this.classList.toggle('is-zoomed', this.zoomed);
      this.choices.forEach(choice => choice.setAttribute('aria-pressed', String(choice.dataset.reticle === this.active)));
      this.querySelectorAll('[data-mode-choice]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.modeChoice === this.mode)));
      this.querySelectorAll('[data-panel]').forEach(panel => panel.hidden = panel.dataset.panel !== this.active);
      const current = this.choices.find(choice => choice.dataset.reticle === this.active);
      if (current) {
        this.querySelector('[data-active-name]').textContent = current.dataset.title;
        this.querySelector('[data-active-units]').textContent = this.mode === 'subtensions' ? current.dataset.units : current.dataset.code;
        this.querySelector('[data-status]').textContent = this.mode === 'subtensions' ? current.dataset.measurementNote : current.dataset.note;
      }
      const zoom = this.querySelector('[data-zoom]');
      zoom.setAttribute('aria-pressed', String(this.zoomed));
      zoom.textContent = this.zoomed ? zoom.dataset.zoomOut : zoom.dataset.zoomIn;
      this.querySelector('.triton-scope-reticles__pan').hidden = !this.zoomed;
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["triton-scope-series"] && !Shopify.designMode) return;
  try {
    
function initScopeSeries(root){
 if(root.dataset.initialized)return;root.dataset.initialized='true';
 const tabs=[...root.querySelectorAll('[role="tab"]')];
 function activate(tab){tabs.forEach(t=>{const on=t===tab;t.setAttribute('aria-selected',String(on));t.tabIndex=on?0:-1;const panel=document.getElementById(t.getAttribute('aria-controls'));if(panel)panel.hidden=!on;});}
 tabs.forEach((tab,i)=>{tab.addEventListener('click',()=>activate(tab));tab.addEventListener('keydown',e=>{let j;if(e.key==='ArrowRight')j=(i+1)%tabs.length;if(e.key==='ArrowLeft')j=(i+tabs.length-1)%tabs.length;if(e.key==='Home')j=0;if(e.key==='End')j=tabs.length-1;if(j!==undefined){e.preventDefault();activate(tabs[j]);tabs[j].focus();}});});
 root.querySelectorAll('[data-variant-select]').forEach(select=>select.addEventListener('change',()=>{select.closest('[role="tabpanel"]').querySelector('[data-variant-link]').href=select.value;}));
}
document.querySelectorAll('.ts-series').forEach(initScopeSeries);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('.ts-series').forEach(initScopeSeries));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["triton-series-reticles"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('triton-series-reticle')) {
    customElements.define('triton-series-reticle', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.active = this.querySelector('[data-reticle]')?.dataset.reticle;
        this.mode = 'default';
        this.addEventListener('click', (event) => {
          const choice = event.target.closest('[data-reticle]');
          const mode = event.target.closest('[data-mode]');
          if (choice) this.active = choice.dataset.reticle;
          if (mode) this.mode = mode.dataset.mode;
          this.render();
        });
        this.addEventListener('shopify:block:select', (event) => {
          this.active = event.detail.blockId;
          this.render();
        });
      }
      render() {
        this.querySelectorAll('[data-reticle]').forEach(b => {const selected = b.dataset.reticle === this.active; b.classList.toggle('is-active', selected); b.setAttribute('aria-pressed', String(selected));});
        this.querySelectorAll('[data-mode]').forEach(b => {const selected = b.dataset.mode === this.mode; b.classList.toggle('is-active', selected); b.setAttribute('aria-pressed', String(selected));});
        this.querySelectorAll('[data-panel]').forEach(p => p.hidden = p.dataset.panel !== this.active);
        this.querySelectorAll('[data-view]').forEach(p => p.hidden = p.dataset.view !== this.mode);
      }
    });
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["triton-support-faq"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('triton-faq'))customElements.define('triton-faq',class extends HTMLElement{
 connectedCallback(){if(this.ready)return;this.ready=true;const input=this.querySelector('input');input.addEventListener('input',()=>{const term=input.value.toLowerCase().trim();let count=0;this.querySelectorAll('[data-faq-item]').forEach(item=>{const match=item.textContent.toLowerCase().includes(term);item.hidden=!match;item.open=!!term&&match;if(match)count++});this.querySelectorAll('[data-faq-group]').forEach(group=>{group.hidden=!Array.from(group.querySelectorAll('[data-faq-item]')).some(item=>!item.hidden)});this.querySelector('[data-empty]').hidden=count>0;this.querySelector('nav').hidden=!!term});this.querySelector('nav').addEventListener('click',event=>{if(event.target.closest('a')){input.value='';input.dispatchEvent(new Event('input'))}})}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["triton-youtube-videos"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('triton-youtube-card')) {
    customElements.define('triton-youtube-card', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-video-id]');
          if (!button || !this.contains(button)) return;
          const id = button.dataset.videoId;
          if (!/^[a-zA-Z0-9_-]{11}$/.test(id)) return;
          const frame = document.createElement('iframe');
          frame.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0&playsinline=1';
          frame.title = button.dataset.videoTitle;
          frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
          frame.allowFullscreen = true;
          frame.referrerPolicy = 'strict-origin-when-cross-origin';
          this.replaceChildren(frame);
          frame.focus();
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
